import { Component } from "@angular/core";

@Component({
    selector: EventsManagementComponent.SELECTOR,
    templateUrl: "./events-management.component.html"
})
export class EventsManagementComponent {
    public static SELECTOR: string = "pcg-ng-events-management";
}
